import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'
import { useEPLImage } from 'src/modules/hooks/useEPLImage'

export default (props) => {
  const posterImg = useEPLImage()

  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      offerBanner={{
        title: [
          'Exclusive offer activated!',
          'Get a month of Premier League action for as low at $21.66/month.',
        ],
      }}
      ctaText="Get Access"
      // video={videos.canada_epl.videoUrl}
      poster={posterImg}
      noVideo={true}
      pageTitle="Watch the Premier League all season"
      title={
        <>
          Watch the Premier League <span className="desktop-line-break">all season</span>
        </>
      }
      subtitle="Live games available in 4K Ultra HD. Streaming exclusively on Fubo."
      networkSet="canadaEssentials"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress"
      logoHeight="90px"
      planCardsConfig={{
        plans: [canadaPlanData.soccer_offer],
      }}
      // preselectPlanLength="monthly"
    />
  )
}
